module.exports = __webpack_public_path__ + "static/img/200313.39b826ef.png";